(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pf-candy-decay-oracle"] && !Shopify.designMode) return;
  try {
    
(() => {
  const questions = [
    { text: 'Wähle deinen emotionalen Support-Gegenstand.', answers: [
      { text: 'Ein winziges grünes Wesen', scores: { oracle_cute: 2, oracle_weird: 2, oracle_cozy: 1 } },
      { text: 'Ein süß-gruseliger Totenkopf', scores: { oracle_creepy: 2, oracle_existential: 2, oracle_weird: 1, oracle_cute: 1 } },
      { text: 'Ein verdächtiges Stück Pizza', scores: { oracle_chaotic: 2, oracle_weird: 2, oracle_sweet: 1 } },
      { text: 'Irgendwas, das ich im Müll gefunden habe', scores: { oracle_rebellious: 2, oracle_chaotic: 1, oracle_weird: 2 } }
    ]},
    { text: 'Deine Wand flüstert. Was will sie?', answers: [
      { text: 'Ein Nickerchen und einen Snack', scores: { oracle_cozy: 2, oracle_sweet: 2, oracle_cute: 1 } },
      { text: 'Sich falsch an 2007 erinnern', scores: { oracle_nostalgic: 2, oracle_existential: 1, oracle_weird: 1 } },
      { text: 'Eine winzige verbotene Romanze', scores: { oracle_romantic: 2, oracle_sweet: 2, oracle_weird: 1 } },
      { text: 'Ein kleines öffentliches Ärgernis werden', scores: { oracle_rebellious: 2, oracle_chaotic: 2, oracle_weird: 1 } }
    ]},
    { text: 'Wähle ein absolut vertrauenswürdiges Omen.', answers: [
      { text: 'Drei Erdbeeren auf einem Friedhof', scores: { oracle_creepy: 2, oracle_sweet: 2, oracle_existential: 1 } },
      { text: 'Eine Taube, die zu lange starrt', scores: { oracle_weird: 2, oracle_chaotic: 2, oracle_cute: 1 } },
      { text: 'Eine Katze bei schlechtem Empfang', scores: { oracle_rebellious: 2, oracle_cozy: 1, oracle_cute: 1 } },
      { text: 'Pfannkuchen, die ohne jeden Kontext auftauchen', scores: { oracle_sweet: 2, oracle_cozy: 2, oracle_cute: 1 } }
    ]},
    { text: 'Wie soll die Realität heute enden?', answers: [
      { text: 'Sanft, unter einer seltsamen kleinen Decke', scores: { oracle_cozy: 2, oracle_existential: 1, oracle_cute: 2 } },
      { text: 'Mit Konfetti und einer schlechten Entscheidung', scores: { oracle_chaotic: 2, oracle_rebellious: 2, oracle_sweet: 1 } },
      { text: 'In einem seltsam romantischen Supermarktgang', scores: { oracle_romantic: 2, oracle_nostalgic: 1, oracle_weird: 1 } },
      { text: 'Speicherpunkt. 11:59. Frag nicht.', scores: { oracle_nostalgic: 2, oracle_creepy: 1, oracle_existential: 2 } }
    ]}
  ];

  const verdicts = {
    oracle_weird: 'Das Orakel hat gefährlich hohe Werte an kleine-seltsame-Kreatur-Energie festgestellt.',
    oracle_cute: 'Bei dir wurde verdächtig guter Geschmack diagnostiziert.',
    oracle_cozy: 'Offenbar brauchen deine Wände emotionale Unterstützung.',
    oracle_creepy: 'Das Orakel billigt deinen Geschmack für Dinge, mit denen etwas ganz leicht nicht stimmt.',
    oracle_chaotic: 'Du hast das gewählt. Spirituell.',
    oracle_existential: 'Eine winzige Leere hat diese Auswahl genehmigt.',
    oracle_nostalgic: 'Eine Erinnerung, die du nie hattest, hat gerade um einen Platz an deiner Wand gebeten.',
    oracle_romantic: 'Das Orakel hat Gefühle gefunden, die niemand genehmigt hat.',
    oracle_rebellious: 'Deine Wand weigert sich, sich zu benehmen.',
    oracle_sweet: 'Zuckerwerte kritisch. Geschmackswerte akzeptabel.'
  };
  const formatOrder = { 'Handsignierter Print': 1, 'Wandbild': 2, 'Digitaler Download': 3 };
  const formatNotes = {
    'Handsignierter Print': 'von mir signiert + geprägt im Studio',
    'Wandbild': 'professionell gedruckt',
    'Digitaler Download': 'hochauflösende Datei, sofort verfügbar'
  };

  function parseProducts(root) {
    return Array.from(root.querySelectorAll('[data-pf-oracle-products]')).flatMap((node) => {
      try { const parsed = JSON.parse(node.textContent); return Array.isArray(parsed) ? parsed : []; }
      catch (error) { return []; }
    });
  }

  function buildArtworks(products) {
    const grouped = new Map();
    products.forEach((product) => {
      if (!product || !product.key) return;
      if (!grouped.has(product.key)) grouped.set(product.key, { key: product.key, title: '', tags: [], image: '', imageAlt: '', imagePriority: 0, options: [] });
      const artwork = grouped.get(product.key);
      if (product.title && !artwork.title) artwork.title = product.title;
      if (Array.isArray(product.tags) && product.tags.length) artwork.tags = Array.from(new Set([...artwork.tags, ...product.tags]));
      if (product.image && Number(product.imagePriority || 0) > artwork.imagePriority) {
        artwork.image = product.image;
        artwork.imageAlt = product.imageAlt || product.title || '';
        artwork.imagePriority = Number(product.imagePriority || 0);
      }
      if (product.label && product.url) artwork.options.push({ label: product.label, priceText: product.priceText || '', url: product.url, available: product.available === true });
    });
    return Array.from(grouped.values()).map((artwork) => {
      const seen = new Set();
      artwork.options = artwork.options.filter((option) => {
        const id = `${option.label}|${option.url}`;
        if (seen.has(id)) return false;
        seen.add(id);
        return true;
      }).sort((a,b) => (formatOrder[a.label] || 99) - (formatOrder[b.label] || 99));
      return artwork;
    }).filter((artwork) => artwork.title && artwork.tags.length && artwork.image && artwork.options.some((option) => option.available));
  }

  function createElement(tag, className, text) {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (typeof text === 'string') element.textContent = text;
    return element;
  }

  function initOracle(root) {
    if (!root || root.dataset.pfOracleReady === 'true') return;
    root.dataset.pfOracleReady = 'true';
    const stage = root.querySelector('[data-pf-oracle-stage]');
    const startButton = root.querySelector('[data-pf-oracle-start-button]');
    const artworks = buildArtworks(parseProducts(root));
    if (!stage || !startButton || !artworks.length) return;

    const emptyScores = () => ({ oracle_cute:0, oracle_creepy:0, oracle_chaotic:0, oracle_cozy:0, oracle_weird:0, oracle_nostalgic:0, oracle_existential:0, oracle_romantic:0, oracle_rebellious:0, oracle_sweet:0 });
    let scores = emptyScores();

    function swap(render) {
      stage.classList.add('is-leaving');
      window.setTimeout(() => { stage.replaceChildren(); render(); stage.classList.remove('is-leaving'); }, 160);
    }
    function addScores(answerScores) { Object.entries(answerScores).forEach(([tag,value]) => { scores[tag] = (scores[tag] || 0) + Number(value || 0); }); }
    function pickArtwork() {
      const rankedTags = Object.entries(scores).filter(([,score]) => score > 0).sort((a,b) => b[1] - a[1]);
      const topScore = rankedTags.length ? rankedTags[0][1] : 0;
      const priorityTags = new Set(rankedTags.filter(([,score]) => score >= Math.max(1, topScore - 2)).map(([tag]) => tag));
      const rankedArtworks = artworks.map((artwork) => ({ artwork, matchScore: (artwork.tags.filter((tag) => priorityTags.has(tag)).length * 10) + artwork.tags.reduce((total,tag) => total + (scores[tag] || 0), 0) }));
      const bestScore = Math.max(...rankedArtworks.map((entry) => entry.matchScore));
      const finalists = rankedArtworks.filter((entry) => entry.matchScore === bestScore);
      return finalists[Math.floor(Math.random() * finalists.length)].artwork;
    }
    function bestVerdictTag(artwork) {
      const matching = artwork.tags.map((tag) => [tag,scores[tag] || 0]).sort((a,b) => b[1] - a[1]);
      if (matching.length && matching[0][1] > 0) return matching[0][0];
      return artwork.tags.find((tag) => verdicts[tag]) || 'oracle_weird';
    }
    function renderQuestion(index) {
      const question = questions[index];
      const view = createElement('div','pf-oracle__quiz');
      view.appendChild(createElement('p','pf-oracle__progress',`${index + 1} / ${questions.length}`));
      const heading = createElement('h3','pf-oracle__question',question.text);
      heading.tabIndex = -1;
      view.appendChild(heading);
      const answers = createElement('div','pf-oracle__answers');
      question.answers.forEach((answer) => {
        const button = createElement('button','pf-oracle__answer',answer.text);
        button.type = 'button';
        button.addEventListener('click',() => {
          addScores(answer.scores);
          if (index < questions.length - 1) swap(() => renderQuestion(index + 1));
          else { const winner = pickArtwork(); swap(() => renderResult(winner)); }
        });
        answers.appendChild(button);
      });
      view.appendChild(answers);
      stage.appendChild(view);
      heading.focus({ preventScroll:true });
    }
    function renderResult(artwork) {
      const result = createElement('div','pf-oracle__result');
      result.appendChild(createElement('p','pf-oracle__result-kicker','DAS CANDY DECAY ORAKEL HAT GESPROCHEN.'));
      const frame = createElement('div','pf-oracle__artwork-frame');
      const image = createElement('img','pf-oracle__artwork');
      image.src = artwork.image;
      image.alt = artwork.imageAlt || artwork.title;
      image.loading = 'lazy';
      frame.appendChild(image);
      result.appendChild(frame);
      const title = createElement('h3','pf-oracle__result-title',artwork.title);
      title.tabIndex = -1;
      result.appendChild(title);
      result.appendChild(createElement('p','pf-oracle__verdict',verdicts[bestVerdictTag(artwork)] || verdicts.oracle_weird));
      result.appendChild(createElement('p','pf-oracle__choice-heading','WÄHLE DEIN FORMAT'));
      result.appendChild(createElement('p','pf-oracle__format-intro','Gleiches Motiv. Wähle die Version, die zu dir passt.'));
      const options = createElement('div','pf-oracle__options');
      artwork.options.filter((option) => option.available).forEach((option) => {
        const link = createElement('a','pf-oracle__option');
        link.href = option.url;
        link.appendChild(createElement('span','pf-oracle__option-main',`${option.label}${option.priceText ? ` · ${option.priceText}` : ''}`));
        if (formatNotes[option.label]) link.appendChild(createElement('span','pf-oracle__option-note',formatNotes[option.label]));
        options.appendChild(link);
      });
      result.appendChild(options);
      const again = createElement('button','pf-oracle__again','NOCH MAL FRAGEN');
      again.type = 'button';
      again.addEventListener('click',() => { scores = emptyScores(); swap(() => renderQuestion(0)); });
      result.appendChild(again);
      stage.appendChild(result);
      title.focus({ preventScroll:true });
    }
    startButton.addEventListener('click',() => { scores = emptyScores(); swap(() => renderQuestion(0)); });
  }

  function initWithin(scope) {
    if (!scope) return;
    if (scope.matches && scope.matches('[data-pf-oracle]')) initOracle(scope);
    if (scope.querySelectorAll) scope.querySelectorAll('[data-pf-oracle]').forEach(initOracle);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',() => initWithin(document),{ once:true });
  else initWithin(document);
  document.addEventListener('shopify:section:load',(event) => initWithin(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
